/*
 * Filename: src/api/mutations/inspection-instance.ts
 * Created Date: Monday, February 2nd 2026, 1:20:43 pm
 * Author: David Phenicie
 * @breif: mutations for inspection instance API's
 *
 * Copyright (c) 2026 Near Earth Autonomy
 */

import { createMutation } from 'QueryKit'
import { updateInspectionInstanceLabel } from 'API/definitions/iris/inspection-instance'

interface UpdateLabelVariables {
  uuid: string
  label: string
}

const useUpdateInspectionInstanceLabelMutation = createMutation({
  mutationKey: ['inspection-instance_update-label'],
  mutationFn: ({ uuid, label }: UpdateLabelVariables) => updateInspectionInstanceLabel(uuid, label),
  message: 'Failed to update label',
})

export { useUpdateInspectionInstanceLabelMutation }
